module.exports = __webpack_public_path__ + "static/media/example-single-column.901afe51.csv";